import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ProductModal.module.css';
import { openWhatsAppOrder } from '../utils/whatsapp';

const ProductModal = ({ product, onClose, onAddToCart, loading }) => {
    const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);
    const navigate = useNavigate();

    if (!product) return null;

    // Use photo_url fields from product for photos array
    const photos = [
        product.photo_url,
        product.photo_url2,
        product.photo_url3,
        product.photo_url4,
        product.photo_url5,
        product.photo_url6,
        product.photo_url7
    ].filter(Boolean); // filter out undefined or null

    if (loading) {
        return (
            <div className={styles.modalOverlay} onClick={onClose}>
                <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                    Loading...
                </div>
            </div>
        );
    }

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                <button 
                    onClick={onClose} 
                    className={styles.closeButton} 
                    aria-label="Close modal"
                >
                    &times;
                </button>

                <div className={styles.buttonContainer}>
                    <div className={styles.primaryButtonRow}>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                onAddToCart(product);
                            }}
                            className={styles.addToCartButton}
                            title="Add to Cart"
                            aria-label={`Add ${product.item_name} to cart`}
                        >
                            <i className="fa fa-cart-plus" aria-hidden="true"></i>
                        </button>

                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                openWhatsAppOrder(product);
                            }}
                            className={styles.whatsAppButton}
                        >
                            <i className="fa fa-whatsapp" aria-hidden="true"></i> Order via WhatsApp
                        </button>
                    </div>

                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/myproduct/${product.item_id}`);
                        }}
                        className={styles.productPageButton}
                    >
                        Product Page
                    </button>
                </div>

                <div className={styles.productInfo}>
                    {product.category} / {product.brand}  
                </div>

                <h2 className={styles.productName}>{product.item_name}</h2>
                               <h6 className={styles.productInfo}>{product.item_condition}</h6>


                <p className={styles.productDescription}>{product.item_description}</p>

                <div className={styles.photoGallery}>
                    <img 
                        src={photos[selectedPhotoIndex]} 
                        alt={`${product.item_name} - ${selectedPhotoIndex + 1}`} 
                        className={styles.mainPhoto}
                    />
                    <div className={styles.thumbnailContainer}>
                        {photos.map((photo, index) => (
                            <img
                                key={index}
                                src={photo}
                                alt={`${product.item_name} thumbnail ${index + 1}`}
                                className={`${styles.thumbnail} ${selectedPhotoIndex === index ? styles.thumbnailSelected : ''}`}
                                onClick={() => setSelectedPhotoIndex(index)}
                                tabIndex={0}
                                onKeyPress={(e) => { if (e.key === 'Enter') setSelectedPhotoIndex(index); }}
                            />
                        ))}
                    </div>
                </div>

                <p className={styles.productFeature}>{product.item_feature}</p>
            </div>
        </div>
    );
};

export default ProductModal;
